import React, { useEffect, useState } from "react";
import "./TableBookings.css";
import Modal from "../components/Modal";

export default function EasterBookings({ setIsAnyModalActive }) {
  const [slots, setSlots] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openSlot, setOpenSlot] = useState(null);

  const [selectedBookingId, setSelectedBookingId] = useState(null);

  // NEW: delete loading state
  const [deleting, setDeleting] = useState(false);

  const fetchBookings = async (showLoader = true) => {
    if (showLoader) setLoading(true);

    try {
      const res = await fetch(
        "https://admin.deedelicious.com/php/get-easter-bookings.php",
      );
      const data = await res.json();

      if (data.success) {
        setSlots(data.slots);
      }
    } catch (err) {
      console.error(err);
    } finally {
      if (showLoader) setLoading(false);
    }
  };

  useEffect(() => {
    fetchBookings(true);
  }, []);

  const toggleSlot = (key) => {
    setOpenSlot(openSlot === key ? null : key);
  };

  // OPEN MODAL
  const openDeleteModal = (id) => {
    setSelectedBookingId(id);
    setIsAnyModalActive(true);
  };

  // CLOSE MODAL
  const closeModal = () => {
    setSelectedBookingId(null);
    setIsAnyModalActive(false);
  };

  // DELETE BOOKING (UPDATED)
  const handleDeleteBooking = async (e) => {
    e.preventDefault();

    if (deleting) return;

    setDeleting(true);

    try {
      const res = await fetch(
        "https://admin.deedelicious.com/php/delete-easter-booking.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: selectedBookingId }),
        },
      );

      const data = await res.json();

      if (data.success) {
        await fetchBookings(false); // refresh without full loader
        closeModal();
      } else {
        alert(data.message || "Delete failed");
      }
    } catch (err) {
      console.error(err);
    } finally {
      setDeleting(false);
    }
  };

  return (
    <div className="dd-admin-wrapper">
      <h2>Easter Buffet Bookings</h2>

      {/* GLOBAL LOADER */}
      {loading && (
        <div className="spinner-overlay">
          <div className="spinner"></div>
        </div>
      )}

      {!loading &&
        slots.map((slot, index) => {
          const slotKey = `${slot.date_raw}-${slot.time_raw}`;
          const isOpen = openSlot === slotKey;

          return (
            <div key={index} className="slot-section">
              {/* SLOT HEADER */}
              <div
                className={`slot-header ${slot.isFull ? "full" : ""}`}
                onClick={() => toggleSlot(slotKey)}
              >
                <h3>
                  {slot.date} | {slot.time_slot}
                </h3>

                <div className={`slot-badge ${slot.isFull ? "full" : ""}`}>
                  {slot.booked}/{slot.capacity} seats
                  {slot.isFull && " 🔴 FULL"}
                </div>
              </div>

              {/* TABLE */}
              {isOpen && (
                <div className="table-scroll">
                  <table className="dd-table">
                    <thead>
                      <tr>
                        <th>S/N</th>
                        <th>Booking Ref</th>
                        <th>Name</th>
                        <th>Phone</th>
                        <th>Email</th>
                        <th>Adults</th>
                        <th>Children</th>
                        <th>Total</th>
                        <th>Action</th>
                      </tr>
                    </thead>

                    <tbody>
                      {slot.bookings.length === 0 ? (
                        <tr>
                          <td colSpan="9" className="dd-no-data">
                            No bookings for this slot
                          </td>
                        </tr>
                      ) : (
                        slot.bookings.map((b, i) => (
                          <tr key={b.id}>
                            <td>{i + 1}</td>
                            <td>{b.booking_ref}</td>
                            <td>{b.name}</td>
                            <td>{b.phone}</td>
                            <td>{b.email}</td>
                            <td>{b.adults}</td>
                            <td>{b.children}</td>
                            <td>{b.total_guests}</td>
                            <td>
                              <button
                                className="delete-btn"
                                onClick={() => openDeleteModal(b.id)}
                              >
                                <i className="fa fa-trash"></i>
                              </button>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          );
        })}

      {/* DELETE MODAL */}
      {selectedBookingId && (
        <Modal
          title="Confirm Delete"
          onClose={closeModal}
          onSubmit={handleDeleteBooking}
          submitButtonText={
            deleting ? (
              <span>
                <i className="fa fa-spinner fa-spin"></i> Deleting...
              </span>
            ) : (
              "Delete"
            )
          }
          showCancel={true}
          showSubmitButton={true}
          className="delete-modal"
          submitDisabled={deleting}
        >
          <div className="delete-modal-heading">
            <p>Are you sure you want to delete this booking?</p>
            <p>This action cannot be undone.</p>
          </div>
        </Modal>
      )}
    </div>
  );
}
